import { render, staticRenderFns } from "./SimpleTableColumn.vue?vue&type=template&id=3004717f&scoped=true&"
import script from "./SimpleTableColumn.vue?vue&type=script&lang=js&"
export * from "./SimpleTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTableColumn.vue?vue&type=style&index=0&id=3004717f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3004717f",
  null
  
)

export default component.exports